<template>
	<div>
		<div class="product-list">
			<div class="product-item" v-for="(product,index) in products" :key="index" @click="handleDetail(product)"
				:style="{'border':selectIndex==index?'2px solid #D9001B':'0'}">
				<div class="product-image" :style="{height:productItemWidth+'px !important'}">
					<img :src="product.small">
				</div>
				<div style="padding: 10px;">
					<div class="product-name" :title="product.goodsName">{{ product.goodsName }}</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<div class="product-price">
							<span>{{currencySymbol}}</span>
							<span style="margin-left: 3px;">{{ product.price.toFixed(2) }}</span>
						</div>
						<div class="product-sale">
							{{$t('sales')}}：{{ product.buyCount }}
						</div>
					</div>
				</div>
				<!-- 选择货源按钮 -->
				<div class="select-source-btn-container" v-show="isShowBuy">
					<el-button type="danger" size="medium" class="show-buy-btn" @click.stop="selectSource(index)">
						{{ $t('selectThisSource') }}
					</el-button>
				</div>
			</div>
			<div class="nodata" v-if="goodsLoading==='waiting'" style="margin-top: 100px;"
				:style="{'width':isShowBuy?'1100px':'1200px'}">
				<img src="/icon/common/icon-search.png" style="width: auto;height: 150px;">
				<span>{{$t('uploadImageSearch')}}</span>
			</div>

			<div class="nodata" v-if="goodsLoading==='searching'" style="margin-top: 100px;"
				:style="{'width':isShowBuy?'1100px':'1200px'}">
				<img src="/icon/common/icon-search.png" style="width: auto;height: 150px;">
				<span>{{$t('recognizingSearching')}}</span>
			</div>

			<div class="nodata" v-if="products.length==0&&goodsLoading=='finish'" style="margin-top: 150px;"
				:style="{'width':isShowBuy?'1100px':'1200px'}">
				<img src="/icon/common/nodata.png">
				<span>{{$t('noData')}}</span>
			</div>
		</div>
		<div style="display: flex;width: 1200px;justify-content: center;">
			<div v-if="loadingMore" class="loading-more" style="margin: 30px 0; text-align: center;">
				<i class="el-icon-loading"></i>
				<span>{{$t('dataLoading')}}</span>
			</div>
		</div>
		<!-- 

			<div v-if="!hasMore&&products.length>0" class="load-all"
				style="margin: 30px 0; text-align: center; color: #999;">
				{{$t('loadingFinish')}}
			</div>
		 -->
	</div>
</template>

<script>
	import storage from "@/utils/storage.js";
	import goodsApi from '@/api/product';
	export default {
		name: 'ProductList',
		props: {
			//商品列表信息
			goods: {
				type: Array,
				default: null
			},
			//选中的商品索引
			selectIndex: {
				type: Number,
				default: null
			},
			loading: {
				type: String,
				default: 'waiting'
			},
			isShowBuy: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				productItemWidth: 0,
				goodsLoading: '', //是否显示骨架
				products: [],
				currencySymbol: '',
				isMounted: false, //标记组件是否已挂载
				loadingMore: false
			}
		},
		watch: {
			// 监听goods属性的变化
			goods: {
				handler(newGoods) {
					if (newGoods) {
						this.products = newGoods;
						this.loadingMore = false;
						// 获取product-item的宽度
						this.$nextTick(() => {
							this.getProductItemWidth();
						});
					}
				},
				immediate: true
			},
			// 监听goodsLoading属性的变化
			loading: {
				handler(val) {
					this.goodsLoading = val;
				},
				immediate: true
			}
		},
		mounted() {
			// 组件挂载后添加滚动事件监听器
			this.isMounted = true;
			window.addEventListener('scroll', this.handleScroll);
			// 组件销毁时移除滚动事件监听器
			this.$once('hook:destroyed', () => {
				window.removeEventListener('scroll', this.handleScroll);
			});
			this.currencySymbol = storage.getCurrencySymbol();
		},
		methods: {
			// 处理滚动事件
			handleScroll() {
				if (!this.isMounted || this.loadingMore || this.goodsLoading != 'finish') {
					return;
				}
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
				const clientHeight = document.documentElement.clientHeight || window.innerHeight;
				// 当距离底部小于230px时，加载更多数据
				if (scrollHeight - scrollTop - clientHeight < 230) {
					this.loadMore();
				}
			},
			// 加载更多数据
			loadMore() {
				// 触发加载更多事件，广播给父组件
				this.loadingMore = true;
				this.$emit('load-more');
			},
			//跳转商品详情页
			handleDetail(row) {
				window.open('/product-detail?goodsId=' + row.id);
			},
			selectSource(goodsIndex) {
				this.$emit('select-goods', goodsIndex);
			},
			// 获取product-item的宽度
			getProductItemWidth() {
				// querySelector只会返回匹配的第一个元素，符合需求
				const productItem = document.querySelector('.product-item');
				if (productItem) {
					// 获取元素的宽度
					this.productItemWidth = productItem.offsetWidth;
				}
			},
		}
	}
</script>

<style scoped>
	.product-list {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
		gap: 15px;
		max-width: 1200px;
		margin: 0 auto 25px auto;
	}

	.product-item {
		border: 1px solid #e0e0e0;
		border-radius: 8px;
		text-align: center;
		transition: all 0.3s ease;
		position: relative;
		cursor: pointer;
	}

	.product-item:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		transform: translateY(-2px);
	}

	/* 选择货源按钮样式 */
	.select-source-btn-container {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 2;
		opacity: 0;
		transition: opacity 0.3s ease;
		pointer-events: none;
	}

	.show-buy-btn {
		background-color: #D9001B;
		border-color: #D9001B;
	}

	.product-item:hover .select-source-btn-container {
		opacity: 1;
		pointer-events: auto;
	}

	/* 确保按钮在图片上方显示 */
	.product-image {
		position: relative;
		z-index: 1;
	}

	.product-image {
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;
	}

	.product-image img {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
		transition: transform 0.3s ease;
		border-radius: 8px;
	}

	.product-item:hover .product-image img {
		transform: scale(1.05);
	}

	.product-name {
		font-size: 15px;
		color: #333;
		margin-bottom: 10px;
		height: 40px;
		line-height: 20px;
		overflow: hidden;
		text-overflow: ellipsis;
		text-align: left;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.product-price {
		font-size: 20px;
		font-weight: bold;
		color: #F59A23;
		text-align: left;
	}

	.product-sale {
		font-size: 14px;
		color: #999;
	}

	/* 加载中动画效果 */
	.loading-more {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		gap: 10px;
	}

	.loading-more .el-icon-loading {
		font-size: 24px;
		color: #666;
		animation: rotating 2s linear infinite;
	}

	.loading-more span {
		margin-left: 10px;
		color: #999;
		font-size: 16px;
	}

	@keyframes rotating {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}

	/* 已全部加载样式 */
	.load-all {
		font-size: 16px;
		padding: 10px 0;
	}
</style>